// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import VaccinesIcon from '@mui/icons-material/Vaccines';
import CategoryIcon from '@mui/icons-material/Category';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import EditIcon from '@mui/icons-material/Edit';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    VaccinesIcon,
    CategoryIcon,
    HomeRepairServiceIcon,
    FolderSpecialIcon,
    AddBoxIcon,
    ListAltIcon,
    EditIcon
}

// ==============================|| CLIENTES MENU ITEMS ||============================== //

const producto = {
    id: 'producto',
    title: '',
    type: 'group',
    children: [
        {
            id: 'productoServiciosMainMenu',
            title: 'Productos / Servicios',
            type: 'collapse',
            icon: icoMenu.VaccinesIcon,
            children: [
                {
                    id: 'productos_agregar',
                    title: 'Productos',
                    type: 'collapse',
                    icon: icoMenu.FolderSpecialIcon,
                    children: [
                        {
                            id: 'nuevo_producto',
                            title: 'Crear Producto',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-product/0'
                        },
                        {
                            id: 'lista_productos',
                            title: 'Lista Productos',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-products-view'
                        },
                        {
                            id: 'modificar_precio_producto',
                            title: 'Modificar Precio',
                            type: 'item',
                            icon: icoMenu.EditIcon,
                            url: '/user/modificar-precio-view'
                        },
                    ]
                },
                {
                    id: 'categorias',
                    title: 'Categorías de Productos',
                    type: 'collapse',
                    icon: icoMenu.CategoryIcon,
                    children: [
                        {
                            id: 'nueva_linea',
                            title: 'Crear Línea',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-line/0'
                        },
                        {
                            id: 'lista_lineas',
                            title: 'Lista Líneas',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-line'
                        },                
                        {
                            id: 'nueva_categoria',
                            title: 'Crear Categoría',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-category/0'
                        },
                        {
                            id: 'lista_categorias',
                            title: 'Lista Categorías',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-category'
                        },                
                        {
                            id: 'nueva_subcategoria',
                            title: 'Crear SubCategoría',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-subcategory/0'
                        },
                        {
                            id: 'lista_subcategorias',
                            title: 'Lista SubCategorías',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-subcategory'
                        },                
                        {
                            id: 'nuevo_grupo',
                            title: 'Crear Grupo',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-groups/0'
                        },
                        {
                            id: 'lista_grupos',
                            title: 'Lista Grupos',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-groups'
                        },                
                        
                    ]
                },
                {
                    id: 'servicios_agregar',
                    title: 'Servicios - Gastos',
                    type: 'collapse',
                    icon: icoMenu.HomeRepairServiceIcon,
                    children: [
                        {
                            id: 'nuevo_servicio',
                            title: 'Crear Servicio',
                            type: 'item',
                            icon: icoMenu.AddBoxIcon,
                            url: '/user/new-service/0'
                        },
                        {
                            id: 'lista_servicios',
                            title: 'Lista Servicios',
                            type: 'item',
                            icon: icoMenu.ListAltIcon,
                            url: '/user/list-services-view'
                        }               
                    ]
                },                                         
            ]
        }
    ]
};

export default producto;
